import { getMcpSettings, setPreferredMcpSettings } from 'cimpress-customizr';
import { getFirstSupportedLanguage } from './utils/languages';
import { languageCodes } from './constants/languages';

let settingsCache = {};

const EMPTY_LIST = [];

export const getSettings = (authToken, supportedLanguages = languageCodes, sessionId = undefined) => {
  if (settingsCache.global) {
    return Promise.resolve(settingsCache);
  }
  return getMcpSettings(authToken, sessionId)
    .then(globalSettings => {
      // NOTE: globalSettings.language is the array of preferred languages
      const language = getFirstSupportedLanguage(globalSettings.language || EMPTY_LIST, supportedLanguages);
      settingsCache.global = {
        language,
        regionalSettings: globalSettings.regionalSettings,
        timezone: globalSettings.timezone,
      };
      return settingsCache;
    })
    .catch(err => {
      console.warn(err);
      return settingsCache;
    });
};

export const putGlobalSettings = (authToken, language, regionalSettings, timezone, sessionId = undefined) => {
  return setPreferredMcpSettings(authToken, language, regionalSettings, timezone, sessionId).then(newData => {
    settingsCache = {
      ...settingsCache,
      global: {
        // NOTE: newData.language is the array of preferred languages
        language: newData.language[0],
        regionalSettings: newData.regionalSettings,
        timezone: newData.timezone,
      },
    };
  });
};

export const putAppSettings = (authToken, appSettings) => {
  settingsCache.app = appSettings;
};
